import { z } from 'zod';
import { IsoTimestamp, QuizId, SchoolId, UserId } from './common.js';
export const LateAdmissionState = z.enum([
    'pending',
    'approved',
    'denied',
    'expired',
    'consumed',
]);
export const LateAdmissionRequest = z.object({
    id: z.string().min(1).max(64),
    schoolId: SchoolId,
    quizId: QuizId,
    participantId: UserId,
    studentName: z.string().min(1).max(200).nullable(),
    studentNumber: z.string().max(64).nullable(),
    classroomId: z.string().min(1).max(64).nullable(),
    state: LateAdmissionState,
    version: z.number().int().positive(),
    requestedAt: IsoTimestamp,
    updatedAt: IsoTimestamp,
    expiresAt: IsoTimestamp,
    decision: z.enum(['approve', 'deny']).nullable(),
    decisionReason: z.string().max(500).nullable(),
    decidedAt: IsoTimestamp.nullable(),
    decidedBy: UserId.nullable(),
    decidedByDisplayName: z.string().min(1).max(200).nullable(),
    consumedAt: IsoTimestamp.nullable(),
});
export const StudentLateAdmissionResponse = z.object({
    request: LateAdmissionRequest.nullable(),
    serverTimeMs: z.number().int().nonnegative(),
});
export const ProctorLateAdmissionInboxResponse = z.object({
    pending: z.array(LateAdmissionRequest).max(200),
    resolved: z.array(LateAdmissionRequest).max(200),
    serverTimeMs: z.number().int().nonnegative(),
});
export const ProctorLateAdmissionDecisionRequest = z.object({
    decision: z.enum(['approve', 'deny']),
    expectedVersion: z.number().int().positive(),
    reason: z.string().trim().max(500).optional(),
}).superRefine((decision, context) => {
    if (decision.decision === 'deny' && !decision.reason?.trim()) {
        context.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['reason'],
            message: 'a denial reason is required',
        });
    }
});
export const ProctorLateAdmissionDecisionResponse = z.object({
    outcome: z.enum(['applied', 'idempotent']),
    request: LateAdmissionRequest,
});
export const LateAdmissionEventType = z.enum([
    'late_admission_requested',
    'late_admission_resubmitted',
    'late_admission_approved',
    'late_admission_denied',
    'late_admission_expired',
    'late_admission_consumed',
]);
export const LateAdmissionRequestEvent = z.object({
    id: z.string().min(1).max(128),
    at: IsoTimestamp,
    type: LateAdmissionEventType,
    actorId: UserId.nullable(),
    actorRole: z.string().max(32).nullable(),
    actorDisplayName: z.string().max(200).nullable(),
    reason: z.string().max(500).nullable(),
    previousState: LateAdmissionState.nullable(),
    previousDecision: z.enum(['approve', 'deny']).nullable(),
});
export const ProctorLateAdmissionEventsResponse = z.object({
    events: z.array(LateAdmissionRequestEvent).max(200),
    serverTimeMs: z.number().int().nonnegative(),
});
//# sourceMappingURL=late-admission.js.map